import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// Import mantido por efeito colateral: outras páginas (TodosImoveis,
// LancamentosPlanta, Pesquisa, ComprarImovel, AlugarImovel) dependem
// globalmente das classes definidas aqui (.property-card, .imageCard etc.),
// mesmo não sendo mais usadas neste componente.
import "../styles/construtoras.css";
import "../styles/propertyShowcase.css";

import PropertyShowcaseCarousel from "./PropertyShowcase/PropertyShowcaseCarousel";
import PropertyShowcaseCard from "./PropertyShowcase/PropertyShowcaseCard";

import { useFavorites } from "./Context/FavoritesContext";
import { db } from "../firebaseConfig";
import { ref, onValue } from "firebase/database";

import { Snackbar, Alert } from "@mui/material";

const Construtoras = () => {
  const navigate = useNavigate();

  const { favorites, addFavorite, removeFavorite } = useFavorites();
  const [imoveis, setImoveis] = useState([]);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    const fetchImoveis = () => {
      const imoveisRef = ref(db, "imoveisPublicos/");
      onValue(imoveisRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const imoveisArray = Object.entries(data)
            .map(([id, imovel]) => ({
              id,
              ...imovel,
            }))
            .filter(
              (item) =>
                item.imovelInfo?.construtora === "true" &&
                item.imovelInfo?.status === true
            )
            .reverse();
          setImoveis(imoveisArray);
        } else {
          setImoveis([]);
        }
      });
    };

    fetchImoveis();
  }, []);

  const toggleFavorite = (property) => {
    if (
      favorites.some(
        (fav) => fav.imovelInfo.codigo === property.imovelInfo.codigo
      )
    ) {
      removeFavorite(property.imovelInfo.codigo);
      setToastMessage("Removido dos favoritos!");
    } else {
      addFavorite(property);
      setToastMessage("Adicionado aos favoritos!");
    }
    setToastOpen(true);
  };

  const handleCloseToast = () => {
    setToastOpen(false);
  };

  const handleNavigate = (codigo) => {
    navigate(`/imovel/${codigo}`);
  };

  return (
    <>
      <PropertyShowcaseCarousel
        eyebrow="Incorporação"
        title="Lançamentos na planta"
        items={imoveis}
        getItemKey={(property) => property.id}
        emptyLabel="Carregando imóveis..."
        navPrevLabel="Ver lançamentos anteriores"
        navNextLabel="Ver próximos lançamentos"
        renderItem={(property) => (
          <PropertyShowcaseCard
            property={property}
            isFavorite={favorites.some(
              (fav) => fav.imovelInfo.codigo === property.imovelInfo.codigo
            )}
            onToggleFavorite={toggleFavorite}
            onNavigate={handleNavigate}
          />
        )}
      />

      {/* Toast Notification para favoritos */}
      <Snackbar
        open={toastOpen}
        autoHideDuration={3000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseToast}
          severity="success"
          sx={{
            width: "100%",
            backgroundColor: "var(--verde)",
            color: "var(--brancoUm)",
          }}
        >
          {toastMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Construtoras;
